import {hideSnackbar} from "../actions/snachbarActions";
import {IthSnackbar} from "../misc/SnackbarGroup";
import {connect} from "react-redux";

const m2s = state => ({
	message: state.snackbar.message,
	color: state.snackbar.color
});

const m2d = dispatch => ({
	onRequestClose: () => dispatch(hideSnackbar())
});

export default connect(m2s, m2d)(IthSnackbar);


// WEBPACK FOOTER //
// ./src/containers/SnackbarController.js